import { useSeo } from "@/hooks/useSeo";
import { brand } from "@/mocks/site";
import HomeHero from "./components/HomeHero";
import StatsBar from "./components/StatsBar";
import LatestExposes from "./components/LatestExposes";
import CategorySection from "./components/CategorySection";
import GuidesPreview from "./components/GuidesPreview";
import TestimonialSection from "./components/TestimonialSection";
import FaqPreview from "./components/FaqPreview";
import SubmitCta from "./components/SubmitCta";

export default function Home() {
  useSeo({
    title: "明察爆料 - 网络爆料与防骗避坑资讯平台",
    description:
      "明察爆料是聚焦诈骗套路预警、消费维权与行业乱象的公共利益爆料平台，收录真实踩坑案例与防骗指南，帮你识别假投资、刷单返利、预付卡跑路等常见陷阱。",
    keywords: "网络爆料,诈骗预警,防骗指南,消费维权,避坑案例,资金盘识别",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: brand.name,
        url: brand.domain,
        description: brand.intro,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${brand.domain}/expose?q={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: brand.name,
        url: brand.domain,
        email: brand.email,
        description: brand.positioning
      }
    ]
  });

  return (
    <>
      <HomeHero />
      <StatsBar />
      <LatestExposes />
      <CategorySection />
      <GuidesPreview />
      <TestimonialSection />
      <FaqPreview />
      <SubmitCta />
    </>
  );
}